import moment from "moment";
type Moment = any;

export default {
    moreThanAmountOfMinutesAgo(time: Moment | null | undefined, amountOfMinutes: number): boolean {
        if (!time) {
            return true;
        }
        return moment()
            .subtract(amountOfMinutes, "minutes")
            .isAfter(time);
    },

    getCurrentMonth(): Moment {
        return moment().startOf("month");
    }
};
